import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ProjectStatsCards } from './components/ProjectStatsCards';
import { ProjectCharts } from './components/ProjectCharts';
import { ProjectListBlock } from './components/ProjectListBlock';
import { useProjectsList } from './hooks/useProjectsList';
import { StandardListLayout } from '@/shared/layout/StandardListLayout';
import { DataFilterToolbar, type FilterDefinition } from '@/components/ui/DataFilterToolbar';
import { Plus, Download } from 'lucide-react';

export function ProjectsPage() {
  const navigate = useNavigate();
  const { data, filters, setFilters, isLoading, handlePageChange, handleDeleteProject } = useProjectsList();

  const handleView = (id: string) => navigate(`/projects/${id}`);
  const handleEdit = (id: string) => navigate(`/projects/${id}/edit`);
  const handleAdd = () => navigate('/projects/new');

  const filterDefs: FilterDefinition[] = [
    {
      id: 'type',
      label: 'Danh mục',
      options: [
        { value: 'all', label: 'Tất cả' },
        { value: 'construction', label: 'Thi công' },
        { value: 'maintenance', label: 'Bảo dưỡng' }
      ]
    },
    {
      id: 'status',
      label: 'Trạng thái',
      options: [
        { value: 'all', label: 'Tất cả trạng thái' },
        { value: 'planning', label: 'Lập kế hoạch' },
        { value: 'active', label: 'Đang thực hiện' },
        { value: 'completed', label: 'Đã hoàn thành' },
        { value: 'on_hold', label: 'Tạm dừng' }
      ]
    },
    {
      id: 'region',
      label: 'Khu vực',
      options: [
        { value: 'all', label: 'Tất cả khu vực' },
        { value: 'south', label: 'Miền Nam' },
        { value: 'north', label: 'Miền Bắc' },
        { value: 'central', label: 'Miền Trung' }
      ]
    }
  ];

  return (
    <StandardListLayout
      title="Quản lý dự án"
      description="Quản lý và theo dõi trạng thái tất cả các dự án thi công, bảo dưỡng"
      isLoading={isLoading}
      viewMode="table"
      kpiSection={<ProjectStatsCards summary={data.summary} isLoading={isLoading} />}
      toolbarSection={
        <DataFilterToolbar
          search=""
          onSearchChange={() => {}}
          searchPlaceholder="Tìm kiếm dự án..."
          filterDefs={filterDefs}
          filterValues={{
            type: filters.type || 'all',
            status: filters.status || 'all',
            region: filters.region || 'all'
          }}
          onFilterChange={(k, v) => setFilters({ ...filters, [k]: v || 'all', page: 1 })}
          primaryAction={{
            label: "Thêm dự án",
            icon: Plus,
            onClick: handleAdd
          }}
          secondaryActions={[
            {
              label: "Xuất dữ liệu",
              icon: Download,
              onClick: () => {}
            }
          ]}
        />
      }
      tableSection={
        <ProjectListBlock
          projects={data.projects}
          isLoading={isLoading}
          total={data.total}
          pageSize={filters.pageSize}
          currentPage={filters.page}
          onPageChange={handlePageChange}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteProject}
        />
      }
      cardSection={
        <div className="p-4 text-center text-slate-500">Chế độ xem thẻ chưa được hỗ trợ trên thiết bị di động cho module này.</div>
      }
      sidePanel={
        <ProjectCharts
          summary={data.summary}
          upcoming={data.upcoming}
          isLoading={isLoading}
        />
      }
    />
  );
}

export default ProjectsPage;
